import { Component, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';

import { Router } from '@angular/router';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { LegacyCompositionService } from '@services/legacy-compositions/legacy-composition.service';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-legacy-composition',
    templateUrl: './legacy-composition.component.html',
    styleUrls: ['./legacy-composition.component.scss'],
    providers: [LegacyCompositionService, DialogService],
    standalone: false
})

export class LegacyCompositionComponent implements OnInit {

  public title = 'Legacy Compositions';

  public subtitle: string;

  public pageActions: PageAction[];

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  public columns = [
    { prop: 'title', name: 'Title' },
    {
      prop: 'created', name: 'Created', valueTransformer: function(date) {
        return moment(date).fromNow();
      }
    },
    {
      prop: 'updated', name: 'Last update', valueTransformer: function(date) {
        return moment(date).fromNow();
      }
    },
  ];

  public searchColumns = [{prop: 'title'}];

  public params: any;

  constructor(
    public legacyCompositionService: LegacyCompositionService,
    private router: Router,
    private dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    this.createPageActions();
    this.params = {
      deleted: { $type: 'null' }
    };
  }

  onDetail(event: DataTableEvent) {
    this.router.navigate(['legacy-compositions/', event.row._id]);
  }

  onEdit(event: DataTableEvent) {
    this.router.navigate(['legacy-compositions/', event.row._id, 'edit']);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService
      .confirm('Remove legacy composition?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.legacyCompositionService.remove(event.row._id).then(() => {
          this.dataTable.refresh();
        }).catch(error => {
          const message = (error.error.message ? error.error.message : error.message);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'format_paint',
        title: 'Create new Legacy Composition',
        callback: () => {
          this.router.navigate(['legacy-compositions/create/']);
        }
      })
    ];
  }
}
